import { useEffect } from 'react';
import { ThemeCtx } from './themeContextValue';
const LOCKED_THEME = 'dark';

export function ThemeProvider({ children }) {
  useEffect(() => {
    document.documentElement.setAttribute('data-theme', LOCKED_THEME);
    localStorage.setItem('sl-theme', LOCKED_THEME);
  }, []);

  return (
    <ThemeCtx.Provider value={{ theme: LOCKED_THEME, toggle: () => {} }}>
      {children}
    </ThemeCtx.Provider>
  );
}
